export const AGREEMENT_MENU_LIST = [
  { index: 0, title: '서비스 이용약관', path: '/agreement/service' },
  { index: 1, title: '유료상품 이용약관', path: '/agreement/paid' },
  { index: 2, title: '개인정보 처리방침', path: '/agreement/privacy' },
  { index: 3, title: '청소년 보호정책', path: '/agreement/youth' },
  { index: 4, title: '웨이브온 사업자 이용약관', path: '/agreement/pooqzone' },
  { index: 5, title: '웨이브온 개인정보 처리방침', path: '/agreement/pooqzone_privacy' }
]

export const EVENT_MENU_LIST = [
  { index: 0, title: '진행중인 이벤트', path: '/event/list' },
  { index: 1, title: '당첨자 발표', path: '/event/board' }
]

export const MY_POOQ_VOUCHER_MENU_LIST = [
  { index: 0, title: 'Wavve 이용권', value: 'index', path: '/voucher/index' },
  { index: 1, title: '쿠폰·코인', value: 'regist', path: '/voucher/regist' },
  { index: 2, title: '웨이브온 이용권', value: 'wavveon', path: '/voucher/wavveon' }
]
